export const TEST_ID_CERTIFICATE_MARK_MESSAGE =
  'TEST_ID_CERTIFICATE_MARK_MESSAGE';
export const TEST_ID_CHILD_WITH_PASSPORT_MESSAGE =
  'TEST_ID_CHILD_WITH_PASSPORT_MESSAGE';
export const TEST_ID_VISA_MESSAGE = 'TEST_ID_VISA_MESSAGE';
export const TEST_ID_ELDERLY_PERSON_MESSAGE = 'TEST_ID_ELDERLY_PERSON_MESSAGE';
export const TEST_ID_CHANGING_INFO_MESSAGE = 'TEST_ID_CHANGING_INFO_MESSAGE';
